import React from 'react';
import CardButton from '../../common/components/CardButton';
import MapIcon from '@mui/icons-material/Map';
import { useTranslation } from 'react-i18next';
import { globalAvailableIndexes } from '../../utils/indexes';
import { primary } from '../../theme';
import { Index } from '../../common/utils/indexes';
import { Menu, MenuItem, ListItemText } from '@mui/material';

export interface IndexSelectorProps {
  selectedIndex?: Index;
  availableIndexes: Index[];
  onIndexChange: (index: Index) => void;
  style?: React.CSSProperties;
  iconButtonStyle?: React.CSSProperties;
  isMobile?: boolean;
}

function IndexSelector(props: IndexSelectorProps) {
  const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);
  const dropdownOpen = Boolean(anchorEl);
  const { t } = useTranslation();

  const handleDropdownClick = (event?: React.MouseEvent) => {
    if(dropdownOpen) {
      handleDropdownClose();
    } else if (event) {
      setAnchorEl(event.currentTarget as HTMLElement);
    }
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const handleIndexSelect = (index: Index) => {
    props.onIndexChange(index);
    handleDropdownClose();
  };

  const getText = (index: string | undefined) => {
    if (!index || index === globalAvailableIndexes[0].id) {
      return props.isMobile ? t('analysis.select_output_short') : t('analysis.select_output');
    }
    return t(index);
  }

  return (
    <React.Fragment>
      <CardButton
        onClick={handleDropdownClick}
        icon={<MapIcon />}
        showMore={true}
        text={getText(props.selectedIndex?.name ?? props.selectedIndex?.id)}
        secondaryTextPosition='left'
        style={{
          backgroundColor: dropdownOpen ? primary : undefined,
          color: dropdownOpen ? 'white' : undefined,
          ...props.style
        }}
        iconButtonStyle={{
          color: dropdownOpen ? 'white' : undefined,
          ...props.iconButtonStyle
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={dropdownOpen}
        onClose={handleDropdownClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              maxHeight: 400,
              width: anchorEl ? anchorEl.clientWidth : 'auto',
            },
          },
        }}
      >
        {props.availableIndexes.map((index) => (
          <MenuItem 
            key={index.id} 
            onClick={() => handleIndexSelect(index)}
            selected={props.selectedIndex?.id === index.id}
          >
            <ListItemText primary={t(index.name) + (index.description ? ' - ' + t(index.description) : '')} />
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}

export default IndexSelector;
